import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { AlertProvider } from './components/alert';
import UploadContextProvider from './contexts/UploadContextProvider';
import { setupStore } from './data/store';
import reportWebVitals from './reportWebVitals';

// import('eruda').then(({ default: eruda }) => {
//     eruda.init();
// });

export const store = setupStore();

const reactRoot = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)

reactRoot.render(
    <Provider store={store}>
        <AlertProvider>
            <UploadContextProvider>
                <BrowserRouter>
                    <ErrorBoundary>
                        <App />
                    </ErrorBoundary>
                </BrowserRouter>
            </UploadContextProvider>
        </AlertProvider>
    </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
